import { useTranslationValues } from '@ps/web-shared-components';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

import { CasinoGameInfoCardMax } from '@swf/casino';
import PageNotFound from '@swf/components/PageNotFound/PageNotFound';
import { CacheControl } from '@swf/components/ResponseHeaders/ResponseHeaders';
import type { WidgetFC } from '@swf/core/types/Widget';

import {
  TXTWCL_N0X_play_it_online_at_XXBrandX_ELL,
  TXTWCL_OopsX_Page_not_found
} from './CasinoGameInfoWidget.messages.json';
import { gameInfoWidgetModel, useGameInfoWidgetModel } from './model';

const CasinoGameInfoWidget: WidgetFC<React.FC<RouteComponentProps>> = ({ staticContext = {} }) => {
  const { widgetSelect } = useGameInfoWidgetModel();
  const { games } = useSelector(widgetSelect.get);
  const [game] = games;

  const values = useTranslationValues();
  const { formatMessage } = useIntl();
  const title = game
    ? formatMessage(TXTWCL_N0X_play_it_online_at_XXBrandX_ELL, { 0: game.name, ...values })
    : formatMessage(TXTWCL_OopsX_Page_not_found);

  if (!game) {
    staticContext.statusCode = 404;
    return <PageNotFound />;
  }

  return (
    <>
      <Helmet>
        <meta name="description" content={game.desc?.substring(0, 164)} />
        <meta name="title" content={title} />
        <title>{title}</title>
      </Helmet>
      <CacheControl>public, max-age=1800</CacheControl>
      <CasinoGameInfoCardMax game={game} />
    </>
  );
};

CasinoGameInfoWidget.model = gameInfoWidgetModel;

export default withRouter(CasinoGameInfoWidget);
